import React from "react";
import {DatePicker, Space, TimePicker, Typography} from "antd"
import moment from "moment"
import {ArrowRightOutlined} from "@ant-design/icons"

const {Text} = Typography


export default class DateDataField extends React.Component {

    render() {
        const {edit, propertie, value, onChange} = this.props

        const range = Array.isArray(value)
        const defaultValue = range ? [moment(value[0]), moment(value[1])] : moment(value)
        var displayValue
        var mode
        var Component
        var withTime = false
        var format

        if (propertie.startsWith("[DATE]_")) {
            mode = "date"
            format = "DD/MM/YYYY"
            Component = DatePicker
            if (range) {
                Component = Component.RangePicker
            }
        }

        if (propertie.startsWith("[DATETIME]_")) {
            mode = "date"
            withTime = true
            format = "DD/MM/YYYY HH:mm"
            Component = DatePicker
            if (range) {
                Component = Component.RangePicker
            }
        }

        if (propertie.startsWith("[YEAR]_")) {
            mode = "year"
            format = "YYYY"
            Component = DatePicker
            if (range) {
                Component = Component.RangePicker
            }
        }

        if (propertie.startsWith("[MONTH]_")) {
            mode = "month"
            format = "MM/YYYY"
            Component = DatePicker
            if (range) {
                Component = Component.RangePicker
            }
        }

        if (propertie.startsWith("[TIME]_")) {
            format = "HH:mm"
            Component = TimePicker
            if (range) {
                Component = Component.RangePicker
            }
        }

        if (!edit) {
            if (range) {
                displayValue = (
                    <Space>{moment(value[0]).format(format)} <ArrowRightOutlined/> {moment(value[1]).format(format)}
                    </Space>)
            } else {
                displayValue = moment(value).format(format)
            }
            return <Text>{displayValue}</Text>
        }

        console.log(this.state)

        return (
            <Component
                style={{width: "100%"}}
                picker={mode}
                format={format}
                showTime={withTime}
                defaultValue={defaultValue}
                onChange={(v) => {
                    const changeValue = range ? [v[0].toDate(), v[1].toDate()] : v.toDate()
                    onChange(changeValue)
                }}
            />
        )


    }
}
